import { Link } from "react-router-dom";
import { MapPin, Mail } from "lucide-react";
import { COMPANY } from "@/lib/company";

const COLS = [
  { title: "Azienda", links: [["/chi-siamo", "Chi siamo"], ["/servizi", "I nostri servizi"], ["/contatti", "Contatti"]] },
  { title: "Clienti", links: [["/traccia", "Traccia spedizione"], ["/contatti", "Richiedi informazioni"]] },
  { title: "Legale", links: [["/privacy", "Privacy Policy"], ["/cookie", "Cookie Policy"]] },
];

export const Footer = () => (
  <footer className="bg-black text-slate-400 border-t border-white/10" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid grid-cols-1 md:grid-cols-12 gap-12">
      <div className="md:col-span-5">
        <img src="/logo.jpg" alt="LINCESSO GROUP TRASPORTI" className="h-24 w-auto -ml-2" />
        <p className="mt-4 max-w-sm text-sm leading-relaxed">La tua merce, la nostra responsabilità. Trasporti, spedizioni e logistica con tracciamento online di ogni spedizione.</p>
        <p className="mt-6 flex items-start gap-2 text-sm text-slate-300" data-testid="footer-address">
          <MapPin className="h-4 w-4 mt-0.5 text-[#E50914] shrink-0" />
          {COMPANY.street} — {COMPANY.cap} {COMPANY.city} ({COMPANY.province}), {COMPANY.country}
        </p>
        <a href={`mailto:${COMPANY.supportEmail}`} className="mt-3 flex items-center gap-2 text-sm text-slate-300 hover:text-white transition-colors" data-testid="footer-support-email">
          <Mail className="h-4 w-4 text-[#E50914] shrink-0" /> Assistenza: {COMPANY.supportEmail}
        </a>
      </div>
      {COLS.map((c) => (
        <div key={c.title} className="md:col-span-2">
          <h4 className="font-display text-white uppercase tracking-[0.2em] text-sm font-bold mb-5">{c.title}</h4>
          <ul className="space-y-3 text-sm">
            {c.links.map(([to, label]) => (
              <li key={label}>
                <Link to={to} className="hover:text-white transition-colors" data-testid={`footer-link-${to.slice(1)}-${label.length}`}>{label}</Link>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
    <div className="border-t border-white/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex flex-col sm:flex-row justify-between gap-3 text-xs">
        <span>© {new Date().getFullYear()} {COMPANY.name}. Tutti i diritti riservati.</span>
        <Link to="/admin" className="hover:text-white" data-testid="footer-admin-link">Area riservata</Link>
      </div>
    </div>
  </footer>
);
